import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import 'components/LeverageSlider/LeverageSlider.scss'
import 'components/TokenSelector/TokenSelector.scss'
import 'components/Tooltip/Tooltip.scss'
import { swrGCMiddleware } from 'rfx/lib/swrMiddlewares'
import type { AppProps } from 'next/app'
import { SWRConfig } from 'swr'
import { WagmiProvider } from 'wagmi'
import '../styles/datepicker.css'
import '../styles/globals.css'
import '../styles/performance-calendar.css'
import '../styles/stats.css'
import Head from 'next/head'
import { meta } from './_document'
import { rainbowKitConfig } from 'utils/rainbow-config'
import FullAppWrapper from '@components/FullAppWrapper'
import '@rainbow-me/rainbowkit/styles.css'
import { appWithTranslation } from 'next-i18next'

export const queryClient = new QueryClient()

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <title>{meta.title}</title>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/rfx-favicon/rfx-favicon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/rfx-favicon/rfx-favicon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/rfx-favicon/rfx-favicon.png"
        />
        <link rel="manifest" href="/rfx-favicon/site.webmanifest" />
        <link
          rel="mask-icon"
          href="/rfx-favicon/safari-pinned-tab.svg"
          color="#5bbad5"
        />
        <meta property="og:title" content={meta.title} />
        <meta name="description" content={meta.description} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link
          rel="apple-touch-icon"
          sizes="192x192"
          href="/rfx-favicon/rfx-favicon.png"
        />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta property="og:image" content={meta.image} />

        <meta name="theme-color" content="#ffffff" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@RFX_exchange" />
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:image" content={meta.image} />
        <meta name="google" content="notranslate" />
        <link rel="manifest" href="/manifest.json"></link>
      </Head>
      <WagmiProvider config={rainbowKitConfig}>
        <SWRConfig
          value={{
            refreshInterval: 50000,
            refreshWhenHidden: false,
            refreshWhenOffline: false,
            use: [swrGCMiddleware as any],
          }}
        >
          <QueryClientProvider client={queryClient}>
            <FullAppWrapper Component={Component} pageProps={pageProps} />
          </QueryClientProvider>
        </SWRConfig>
      </WagmiProvider>
    </>
  )
}

export default appWithTranslation(MyApp)
